import { useState } from "react";
import { Link } from "react-router-dom";
import { TrendingUp, Lock, Mail, ShieldCheck } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";
import { SalesBackground } from "@/components/SalesBackground";

const HERO = "https://images.unsplash.com/photo-1758691736548-073bc97cdff4?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400";

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
    } catch (er) {
      setError(errMsg(er));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="relative grid min-h-screen lg:grid-cols-[1.1fr_1fr]">
      <div className="relative hidden overflow-hidden bg-[#0F172A] lg:block">
        <img src={HERO} alt="Sales team" className="absolute inset-0 h-full w-full object-cover opacity-30" />
        <div className="absolute inset-0 bg-gradient-to-br from-[#1E3A8A]/90 via-[#0F172A]/85 to-[#0F172A]" />
        <SalesBackground dark />
        <div className="relative z-10 flex h-full flex-col justify-between p-14 text-white">
          <div className="flex items-center gap-3">
            <div className="grid h-11 w-11 place-items-center rounded-xl bg-white/10 backdrop-blur"><TrendingUp className="h-6 w-6" /></div>
            <p className="font-heading text-2xl font-bold">JLY<span className="text-sky-400">sales</span></p>
          </div>
          <div className="fade-up">
            <p className="text-xs uppercase tracking-[0.3em] text-sky-300">Jlybalance Suite</p>
            <h1 className="font-heading mt-4 text-5xl font-bold leading-[1.1]">Hitung cost, kunci margin,<br />menangkan penawaran.</h1>
            <p className="mt-5 max-w-md text-blue-100/80">Kalkulasi cost IDR & USD, penawaran dengan riwayat revisi & nego, hingga laporan kunjungan sales dalam satu platform premium.</p>
          </div>
          <div className="flex gap-10 text-sm text-blue-100/70">
            <div><p className="font-num text-2xl font-bold text-white">IDR/USD</p>Kurs otomatis</div>
            <div><p className="font-num text-2xl font-bold text-white">7 Hari</p>Masa berlaku</div>
            <div><p className="font-num text-2xl font-bold text-white">PDF/XLSX</p>Laporan</div>
          </div>
        </div>
      </div>
      <div className="relative flex items-center justify-center p-6">
        <SalesBackground />
        <form onSubmit={submit} className="card-premium relative z-10 w-full max-w-md p-10 fade-up" data-testid="login-form">
          <div className="mb-8">
            <p className="font-heading text-3xl font-bold">Masuk</p>
            <p className="mt-1 text-sm text-slate-500">Masuk dengan akun PT Anda atau akun yang diberikan admin PT.</p>
          </div>
          <div className="space-y-4">
            <div className="relative">
              <Mail className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
              <Input className="h-11 pl-10 bg-white" type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email-input" />
            </div>
            <div className="relative">
              <Lock className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
              <Input className="h-11 pl-10 bg-white" type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password-input" />
            </div>
            {error && <p className="rounded-md bg-rose-50 p-2.5 text-sm text-rose-700" data-testid="login-error">{error}</p>}
            <div className="text-right -mt-1"><Link to="/forgot-password" className="text-sm font-medium text-blue-800 hover:underline" data-testid="login-forgot-link">Lupa password?</Link></div>
            <Button type="submit" className="h-11 w-full text-base" disabled={busy} data-testid="login-submit-btn">{busy ? "Memproses..." : "Masuk ke JLYsales"}</Button>
          </div>
          <p className="mt-6 text-center text-sm text-slate-500">Belum punya akun? <Link to="/register" className="font-semibold text-blue-800 hover:underline" data-testid="login-register-link">Daftar di sini</Link></p>
          <p className="mt-4 flex items-center gap-2 text-xs text-slate-400"><ShieldCheck className="h-4 w-4" />Data setiap sales terlindungi & terpisah.</p>
        </form>
      </div>
    </div>
  );
}
